const useTextAreaValidation = (fieldName, validationRules = []) => {
  const validate = val => {
    let errorList = []
    const rules = [...validationRules]
    const label = fieldName?.replace('*', '')

    // Function to clean HTML entities
    const cleanValue = (value) => {
      if (!value) return value;
      return value
        .replace(/&nbsp;/g, ' ')  // Replace &nbsp; with regular space
        .replace(/<br>/g, '')     // Remove <br> tags
        .trim();                  // Remove leading/trailing spaces
    }

    // Clean the input value
    const cleanedVal = cleanValue(val)

    // Modified regex to only match alphanumeric and spaces
    const specialCharRegex = /^[a-zA-Z0-9\s]*$/

    rules.forEach(rule => {
      if (rule.type === 'required' && (!cleanedVal || cleanedVal === '')) {
        errorList.push(`${rule.excludeLabel ? "" : label} ${rule.msg}`)
      }

      if (rule.type === 'noSpecialChar' && cleanedVal && !specialCharRegex.test(cleanedVal)) {
        errorList.push(`${rule.excludeLabel ? "" : label} ${rule.msg}`)
      }
    })

    return errorList[0]
  }

  const onChange = value => {
    return validate(value)
  }

  return { onChange }
}

export default useTextAreaValidation